import { RefObject, useCallback } from 'react'

import useEventListener from './use-event-listener'

type Handler = (event: MouseEvent) => void

function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: Handler,
  mouseEvent: 'mousedown' | 'mouseup' = 'mousedown',
) {
  useEventListener(mouseEvent, (event) => {
    const el = ref?.current

    if (!el || el.contains(event.target as Node)) {
      return
    }

    handler(event)
  })

  const trigger = useCallback(
    (event?: Event) => {
      handler((event as unknown) as MouseEvent)
    },
    [handler],
  )

  return trigger
}

export default useOnClickOutside
